import { IApplicationState } from '../../types/redux';

export const selectPromoIds = (state: IApplicationState): Array<string> => {
  return state.promos.allIds;
};
